import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2PatientRequirementUpdateBySlug: build.query<
      GetV2PatientRequirementUpdateBySlugApiResponse,
      GetV2PatientRequirementUpdateBySlugApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/patient/requirement-update/${queryArg.slug}`,
      }),
    }),
    postV2PatientRequirementUpdateBySlugCardSetup: build.mutation<
      PostV2PatientRequirementUpdateBySlugCardSetupApiResponse,
      PostV2PatientRequirementUpdateBySlugCardSetupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/patient/requirement-update/${queryArg.slug}/card-setup`,
        method: "POST",
        body: queryArg.cardSetupRequest,
      }),
    }),
    postV2PatientRequirementUpdateBySlugCardSetupComplete: build.mutation<
      PostV2PatientRequirementUpdateBySlugCardSetupCompleteApiResponse,
      PostV2PatientRequirementUpdateBySlugCardSetupCompleteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/patient/requirement-update/${queryArg.slug}/card-setup/complete`,
        method: "POST",
      }),
    }),
    getV2PatientRequirementUpdateBySlugContent: build.query<
      GetV2PatientRequirementUpdateBySlugContentApiResponse,
      GetV2PatientRequirementUpdateBySlugContentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/patient/requirement-update/${queryArg.slug}/content`,
      }),
    }),
    postV2PatientRequirementUpdateBySlugVerify: build.mutation<
      PostV2PatientRequirementUpdateBySlugVerifyApiResponse,
      PostV2PatientRequirementUpdateBySlugVerifyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/patient/requirement-update/${queryArg.slug}/verify`,
        method: "POST",
        body: queryArg.sessionVerifyRequest,
      }),
    }),
    getV2ProviderOrganizationsByOrgIdPatientRequirementDefinitions: build.query<
      GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsApiResponse,
      GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/${queryArg.orgId}/patient-requirement-definitions`,
      }),
    }),
    postV2ProviderOrganizationsByOrgIdPatientRequirementDefinitions:
      build.mutation<
        PostV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsApiResponse,
        PostV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/patient-requirement-definitions`,
          method: "POST",
          body: queryArg.definitionCreateRequest,
        }),
      }),
    getV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionId:
      build.query<
        GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdApiResponse,
        GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/patient-requirement-definitions/${queryArg.definitionId}`,
        }),
      }),
    patchV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionId:
      build.mutation<
        PatchV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdApiResponse,
        PatchV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/patient-requirement-definitions/${queryArg.definitionId}`,
          method: "PATCH",
          body: queryArg.definitionUpdateRequest,
        }),
      }),
    getV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatches:
      build.query<
        GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesApiResponse,
        GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/patient-requirement-definitions/${queryArg.definitionId}/batches`,
          params: {
            limit: queryArg.limit,
          },
        }),
      }),
    postV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatches:
      build.mutation<
        PostV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesApiResponse,
        PostV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/patient-requirement-definitions/${queryArg.definitionId}/batches`,
          method: "POST",
          body: queryArg.batchLaunchRequest,
        }),
      }),
    getV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesPreview:
      build.query<
        GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesPreviewApiResponse,
        GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesPreviewApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/patient-requirement-definitions/${queryArg.definitionId}/batches/preview`,
          params: {
            page: queryArg.page,
            per_page: queryArg.perPage,
          },
        }),
      }),
    getV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesBatchId:
      build.query<
        GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesBatchIdApiResponse,
        GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesBatchIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/patient-requirement-definitions/${queryArg.definitionId}/batches/${queryArg.batchId}`,
        }),
      }),
    getV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopy: build.query<
      GetV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopyApiResponse,
      GetV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/${queryArg.orgId}/patient-requirement-request-copy`,
      }),
    }),
    putV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopy:
      build.mutation<
        PutV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopyApiResponse,
        PutV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopyApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/patient-requirement-request-copy`,
          method: "PUT",
          body: queryArg.requestCopyUpdate,
        }),
      }),
    getV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopyPreview:
      build.query<
        GetV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopyPreviewApiResponse,
        GetV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopyPreviewApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/patient-requirement-request-copy/preview`,
        }),
      }),
    getV2ProviderOrganizationsByOrgIdPatientRequirementsMissing: build.query<
      GetV2ProviderOrganizationsByOrgIdPatientRequirementsMissingApiResponse,
      GetV2ProviderOrganizationsByOrgIdPatientRequirementsMissingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/${queryArg.orgId}/patient-requirements/missing`,
        params: {
          patient_requirement_definition_id:
            queryArg.patientRequirementDefinitionId,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirements:
      build.query<
        GetV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirementsApiResponse,
        GetV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirementsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/patients/${queryArg.patientId}/patient-requirements`,
        }),
      }),
    postV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirementsRequirementIdReopen:
      build.mutation<
        PostV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirementsRequirementIdReopenApiResponse,
        PostV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirementsRequirementIdReopenApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/patients/${queryArg.patientId}/patient-requirements/${queryArg.requirementId}/reopen`,
          method: "POST",
        }),
      }),
    postV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirementsRequirementIdWaive:
      build.mutation<
        PostV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirementsRequirementIdWaiveApiResponse,
        PostV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirementsRequirementIdWaiveApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/patients/${queryArg.patientId}/patient-requirements/${queryArg.requirementId}/waive`,
          method: "POST",
          body: queryArg.waiveRequest,
        }),
      }),
    getV2ProviderOrganizationsByOrgIdPatientsAndPatientIdRequirementRequests:
      build.query<
        GetV2ProviderOrganizationsByOrgIdPatientsAndPatientIdRequirementRequestsApiResponse,
        GetV2ProviderOrganizationsByOrgIdPatientsAndPatientIdRequirementRequestsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/patients/${queryArg.patientId}/requirement-requests`,
        }),
      }),
    postV2ProviderOrganizationsByOrgIdPatientsAndPatientIdRequirementRequests:
      build.mutation<
        PostV2ProviderOrganizationsByOrgIdPatientsAndPatientIdRequirementRequestsApiResponse,
        PostV2ProviderOrganizationsByOrgIdPatientsAndPatientIdRequirementRequestsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/${queryArg.orgId}/patients/${queryArg.patientId}/requirement-requests`,
          method: "POST",
          body: queryArg.sendRequestBody,
        }),
      }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2PatientRequirementUpdateBySlugApiResponse =
  /** status 200 OK */ SessionResolutionResponse;
export type GetV2PatientRequirementUpdateBySlugApiArg = {
  slug: string;
};
export type PostV2PatientRequirementUpdateBySlugCardSetupApiResponse =
  /** status 200 OK */ CardSetupResponse;
export type PostV2PatientRequirementUpdateBySlugCardSetupApiArg = {
  slug: string;
  cardSetupRequest: CardSetupRequest;
};
export type PostV2PatientRequirementUpdateBySlugCardSetupCompleteApiResponse =
  /** status 200 OK */ CardSetupCompleteResponse;
export type PostV2PatientRequirementUpdateBySlugCardSetupCompleteApiArg = {
  slug: string;
};
export type GetV2PatientRequirementUpdateBySlugContentApiResponse =
  /** status 200 OK */ SessionContentResponse;
export type GetV2PatientRequirementUpdateBySlugContentApiArg = {
  slug: string;
};
export type PostV2PatientRequirementUpdateBySlugVerifyApiResponse =
  /** status 200 OK */ SessionVerifyResponse;
export type PostV2PatientRequirementUpdateBySlugVerifyApiArg = {
  slug: string;
  sessionVerifyRequest: SessionVerifyRequest;
};
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsApiResponse =
  /** status 200 OK */ DefinitionListResponse;
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsApiArg =
  {
    orgId: string;
  };
export type PostV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsApiResponse =
  /** status 201 Created */ DefinitionResponse2;
export type PostV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsApiArg =
  {
    orgId: string;
    definitionCreateRequest: DefinitionCreateRequest;
  };
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdApiResponse =
  /** status 200 OK */ DefinitionResponse2;
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdApiArg =
  {
    orgId: string;
    definitionId: string;
  };
export type PatchV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdApiResponse =
  /** status 200 OK */ DefinitionResponse2;
export type PatchV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdApiArg =
  {
    orgId: string;
    definitionId: string;
    definitionUpdateRequest: DefinitionUpdateRequest;
  };
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesApiResponse =
  /** status 200 OK */ BatchListResponse;
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesApiArg =
  {
    orgId: string;
    definitionId: string;
    /** Newest first; the catalog row polls this with limit=1 */
    limit?: number;
  };
export type PostV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesApiResponse =
  /** status 200 OK */
    | PatientRequirementBatchProgressResponse2
    | /** status 201 Created */ PatientRequirementBatchProgressResponse2;
export type PostV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesApiArg =
  {
    orgId: string;
    definitionId: string;
    batchLaunchRequest: BatchLaunchRequest;
  };
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesPreviewApiResponse =
  /** status 200 OK */ BatchPreviewResponse;
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesPreviewApiArg =
  {
    orgId: string;
    definitionId: string;
    page?: number;
    perPage?: number;
  };
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesBatchIdApiResponse =
  /** status 200 OK */ PatientRequirementBatchProgressResponse2;
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementDefinitionsAndDefinitionIdBatchesBatchIdApiArg =
  {
    orgId: string;
    definitionId: string;
    batchId: string;
  };
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopyApiResponse =
  /** status 200 OK */ RequestCopyResponse;
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopyApiArg =
  {
    orgId: string;
  };
export type PutV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopyApiResponse =
  /** status 200 OK */ RequestCopyResponse;
export type PutV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopyApiArg =
  {
    orgId: string;
    requestCopyUpdate: RequestCopyUpdate;
  };
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopyPreviewApiResponse =
  /** status 200 OK */ MessagePreviewResponse;
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementRequestCopyPreviewApiArg =
  {
    orgId: string;
  };
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementsMissingApiResponse =
  /** status 200 OK */ MissingListResponse;
export type GetV2ProviderOrganizationsByOrgIdPatientRequirementsMissingApiArg =
  {
    orgId: string;
    /** The definition whose open rows to list */
    patientRequirementDefinitionId: string;
    page?: number;
    perPage?: number;
  };
export type GetV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirementsApiResponse =
  /** status 200 OK */ RequirementListResponse;
export type GetV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirementsApiArg =
  {
    orgId: string;
    patientId: string;
  };
export type PostV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirementsRequirementIdReopenApiResponse =
  /** status 200 OK */ RequirementResponse3;
export type PostV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirementsRequirementIdReopenApiArg =
  {
    orgId: string;
    patientId: string;
    requirementId: string;
  };
export type PostV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirementsRequirementIdWaiveApiResponse =
  /** status 200 OK */ RequirementResponse3;
export type PostV2ProviderOrganizationsByOrgIdPatientsAndPatientIdPatientRequirementsRequirementIdWaiveApiArg =
  {
    orgId: string;
    patientId: string;
    requirementId: string;
    waiveRequest: WaiveRequest;
  };
export type GetV2ProviderOrganizationsByOrgIdPatientsAndPatientIdRequirementRequestsApiResponse =
  /** status 200 OK */ DeliveryHistoryResponse;
export type GetV2ProviderOrganizationsByOrgIdPatientsAndPatientIdRequirementRequestsApiArg =
  {
    orgId: string;
    patientId: string;
  };
export type PostV2ProviderOrganizationsByOrgIdPatientsAndPatientIdRequirementRequestsApiResponse =
  /** status 200 OK */ SendOutcomeResponse;
export type PostV2ProviderOrganizationsByOrgIdPatientsAndPatientIdRequirementRequestsApiArg =
  {
    orgId: string;
    patientId: string;
    sendRequestBody: SendRequestBody;
  };
export type SessionResolutionResponse = {
  requires_verification?: boolean;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type CardSetupResponse = {
  setup_intent_client_secret: string;
  stripe_account_id: string;
};
export type CardSetupRequest = {
  /** Version of the standard JotPsych consent text the patient accepted (Q4) */
  consent_text_version: string;
};
export type CardSetupCompleteResponse = {
  complete: boolean;
  patient_update_session_id: string;
  satisfied_requirement_ids: string[];
  state: string;
};
export type LastRequestOutcomeResponse = {
  /** When that attempt was made */
  at?: string | null;
  /** sms | email — the channel this outcome describes. Null when no channel was tried at all, which is what no_eligible_channel means. */
  channel?: string | null;
  /** Why it failed, when it did: invalid_address | unreachable | unsubscribed | no_eligible_channel | failed_other. The causes differ in what staff can do — an address is fixable, an opt-out is not and re-sending it is a compliance problem — so the copy is per cause rather than one line for all failures. Only SMS carries a vendor code today, so every email failure reports failed_other; treat that as "we do not know", not as "the address is fine". */
  reason?: string | null;
  /** delivered | failed. Delivered rests on a delivery confirmation from the carrier, not on the message having been accepted for sending. */
  status: string;
};
export type RequirementResponse = {
  assigned_at?: string | null;
  /** Product vocabulary: Missing|Received|Waived|Cancelled */
  display_state: string;
  evidence_type?: string | null;
  /** A live update request exists (Send reads Remind) */
  has_active_session?: boolean;
  /** The definition's kind (payment_method | ...) */
  kind?: string | null;
  /** The definition's org-facing label */
  label?: string | null;
  /** Channel of that attempt (sms | email) */
  last_request_channel?: string | null;
  /** What became of the last request. Null when no request was ever made, and while one is still in flight — delivery is claimed only once the carrier says so. A failed outcome is what distinguishes a requirement nobody has chased from one that was chased and never arrived. */
  last_request_outcome?: LastRequestOutcomeResponse | null;
  /** When the latest accepted request attempt was sent */
  last_requested_at?: string | null;
  patient_id: string;
  patient_requirement_definition_id: string;
  patient_requirement_id: string;
  pinned_version?: number | null;
  satisfied_at?: string | null;
  /** Storage state: open|satisfied|waived|cancelled */
  state: string;
  waive_reason?: string | null;
  waived_at?: string | null;
  waived_by_user_id?: string | null;
};
export type SessionContentResponse = {
  consent_recorded: boolean;
  needs_card_setup: boolean;
  open_requirements: RequirementResponse[];
  patient_update_session_id: string;
  state: string;
};
export type SessionVerifyResponse = {
  patient_update_session_id: string;
  /** Patient JWT for the session surfaces */
  token: string;
};
export type SessionVerifyRequest = {
  /** Patient date of birth (YYYY-MM-DD) */
  dob: string;
};
export type DefinitionResponse = {
  active: boolean;
  default_for_new_patients: boolean;
  kind: string;
  label: string;
  materialization_already_had?: number | null;
  materialization_born_open?: number | null;
  materialization_born_satisfied?: number | null;
  materialization_completed_at?: string | null;
  materialization_panel_size?: number | null;
  /** checking while activation evaluates the panel; done when the counts below are written. The create confirmation polls this. */
  materialization_status: "checking" | "done";
  patient_instructions?: string | null;
  patient_requirement_definition_id: string;
  sort_order: number;
};
export type DefinitionListResponse = {
  items: DefinitionResponse[];
};
export type DefinitionResponse2 = {
  active: boolean;
  default_for_new_patients: boolean;
  kind: string;
  label: string;
  materialization_already_had?: number | null;
  materialization_born_open?: number | null;
  materialization_born_satisfied?: number | null;
  materialization_completed_at?: string | null;
  materialization_panel_size?: number | null;
  /** checking while activation evaluates the panel; done when the counts below are written. The create confirmation polls this. */
  materialization_status: "checking" | "done";
  patient_instructions?: string | null;
  patient_requirement_definition_id: string;
  sort_order: number;
};
export type DefinitionCreateRequest = {
  default_for_new_patients?: boolean;
  /** payment_method | insurance_card | form */
  kind: string;
  /** Patient-facing label */
  label: string;
  patient_instructions?: string | null;
  sort_order?: number;
};
export type DefinitionUpdateRequest = {
  active?: boolean | null;
  default_for_new_patients?: boolean | null;
  label?: string | null;
  patient_instructions?: string | null;
  sort_order?: number | null;
};
export type BatchMessageCounts = {
  cancelled: number;
  /** The carrier confirmed it landed */
  delivered: number;
  failed: number;
  queued: number;
  /** A provider accepted it */
  sent: number;
  total: number;
};
export type BatchPatientCounts = {
  /** Targeted patients whose requirement is now satisfied. Keeps rising after the batch finishes — the batch stops sending, the patients do not stop completing — and is read off the requirement rows rather than accumulated, so it cannot drift. */
  completed: number;
  outstanding: number;
  /** Patients the batch targeted but did not message, carrying the preview's exclusion reasons. Not failures. */
  skipped: number;
  targeted: number;
};
export type PatientRequirementBatchProgressResponse = {
  batch_id: string;
  cancelled_at?: string | null;
  created_at?: string | null;
  finished_at?: string | null;
  launched_by_user_id: string;
  messages: BatchMessageCounts;
  patient_requirement_definition_id: string;
  patients: BatchPatientCounts;
  started_at?: string | null;
  /** queued | running | finished | cancelled. 'finished' describes the batch; patients complete on their own schedule. */
  state: string;
};
export type BatchListResponse = {
  items: PatientRequirementBatchProgressResponse[];
};
export type BatchMessageCounts2 = {
  cancelled: number;
  /** The carrier confirmed it landed */
  delivered: number;
  failed: number;
  queued: number;
  /** A provider accepted it */
  sent: number;
  total: number;
};
export type BatchPatientCounts2 = {
  /** Targeted patients whose requirement is now satisfied. Keeps rising after the batch finishes — the batch stops sending, the patients do not stop completing — and is read off the requirement rows rather than accumulated, so it cannot drift. */
  completed: number;
  outstanding: number;
  /** Patients the batch targeted but did not message, carrying the preview's exclusion reasons. Not failures. */
  skipped: number;
  targeted: number;
};
export type PatientRequirementBatchProgressResponse2 = {
  batch_id: string;
  cancelled_at?: string | null;
  created_at?: string | null;
  finished_at?: string | null;
  launched_by_user_id: string;
  messages: BatchMessageCounts2;
  patient_requirement_definition_id: string;
  patients: BatchPatientCounts2;
  started_at?: string | null;
  /** queued | running | finished | cancelled. 'finished' describes the batch; patients complete on their own schedule. */
  state: string;
};
export type BatchLaunchRequest = {
  /** Client-generated. Mint it when the confirm dialog opens, not when the button is clicked, so a double-click, an impatient re-click and a retry after a timeout all carry the same key. */
  idempotency_key: string;
};
export type ExcludedPatientResponse = {
  /** Patient full name; None if unloadable */
  patient_display_name?: string | null;
  patient_id: string;
  /** The one reason this patient is counted under: active_session_exists | channel_suppressed | no_contact_info | channel_avoided | patient_not_readable */
  primary_reason: string;
  /** Every reason that applied. A patient blocked on two counts is one exclusion in the counts and two facts here. */
  reasons: string[];
};
export type BatchPreviewPatientCounts = {
  /** Verified as satisfied while the preview read them — its own bucket, never an exclusion reason. Non-zero is the preview working, not an error state. */
  already_complete: number;
  eligible: number;
  excluded: number;
  /** Patients per primary reason; sums exactly to excluded, because each patient is counted once */
  excluded_by_reason: {
    [key: string]: number;
  };
  /** The definition's open population at preview time */
  read: number;
};
export type BatchPreviewResponse = {
  /** Eligible patients per channel. The only count here that is not per patient: someone reachable on both appears in both, which is why a 128-patient preview runs as 217 messages. */
  channels: {
    [key: string]: number;
  };
  /** One page of the excluded patients */
  excluded: ExcludedPatientResponse[];
  page: number;
  patient_requirement_definition_id: string;
  patients: BatchPreviewPatientCounts;
  per_page: number;
  /** The population scan hit a guard rail, so the counts are a floor and not the whole population. The buckets still sum, so this flag is the only way to tell — do not offer a launch on it. */
  truncated?: boolean;
};
export type EmailCopyResponse = {
  /** Email body, without the secure link */
  body: string;
  /** True when this channel has never been saved */
  is_default: boolean;
  subject: string;
};
export type SmsCopyResponse = {
  /** SMS body, without the secure link */
  body: string;
  characters: number;
  /** True when this channel has never been saved and this is the seed. Per channel, so the editor can offer Reset on one without touching the other. */
  is_default: boolean;
  /** How many SMS segments this body needs. Stated, never enforced: the practice decides what to do about it. */
  segments: number;
};
export type RequestCopyResponse = {
  email: EmailCopyResponse;
  /** True when neither channel has been saved. Per-channel flags are on sms and email. */
  is_default: boolean;
  /** The token a save is refused for. The link is appended to every message, so copy must not contain it; the editor can warn on a paste rather than let the save fail. */
  link_placeholder: string;
  sms: SmsCopyResponse;
  updated_at?: string | null;
  updated_by_user_id?: string | null;
};
export type EmailCopyRequest = {
  body: string;
  subject: string;
};
export type SmsCopyRequest = {
  body: string;
};
export type RequestCopyUpdate = {
  email?: EmailCopyRequest | null;
  sms?: SmsCopyRequest | null;
};
export type MessagePreviewEmail = {
  body: string;
  subject: string;
};
export type MessagePreviewSms = {
  body: string;
  characters: number;
  segments: number;
};
export type MessagePreviewResponse = {
  email: MessagePreviewEmail;
  sms: MessagePreviewSms;
};
export type LastRequestOutcomeResponse2 = {
  /** When that attempt was made */
  at?: string | null;
  /** sms | email — the channel this outcome describes. Null when no channel was tried at all, which is what no_eligible_channel means. */
  channel?: string | null;
  /** Why it failed, when it did: invalid_address | unreachable | unsubscribed | no_eligible_channel | failed_other. The causes differ in what staff can do — an address is fixable, an opt-out is not and re-sending it is a compliance problem — so the copy is per cause rather than one line for all failures. Only SMS carries a vendor code today, so every email failure reports failed_other; treat that as "we do not know", not as "the address is fine". */
  reason?: string | null;
  /** delivered | failed. Delivered rests on a delivery confirmation from the carrier, not on the message having been accepted for sending. */
  status: string;
};
export type MissingItemResponse = {
  assigned_at?: string | null;
  /** Product vocabulary: Missing|Received|Waived|Cancelled */
  display_state: string;
  evidence_type?: string | null;
  /** A live update request exists (Send reads Remind) */
  has_active_session?: boolean;
  /** The definition's kind (payment_method | ...) */
  kind?: string | null;
  /** The definition's org-facing label */
  label?: string | null;
  /** Channel of that attempt (sms | email) */
  last_request_channel?: string | null;
  /** What became of the last request. Null when no request was ever made, and while one is still in flight — delivery is claimed only once the carrier says so. A failed outcome is what distinguishes a requirement nobody has chased from one that was chased and never arrived. */
  last_request_outcome?: LastRequestOutcomeResponse2 | null;
  /** When the latest accepted request attempt was sent */
  last_requested_at?: string | null;
  /** Patient full name; None if unloadable */
  patient_display_name?: string | null;
  /** Patient date of birth (YYYY-MM-DD) */
  patient_dob?: string | null;
  patient_id: string;
  patient_requirement_definition_id: string;
  patient_requirement_id: string;
  pinned_version?: number | null;
  satisfied_at?: string | null;
  /** Storage state: open|satisfied|waived|cancelled */
  state: string;
  waive_reason?: string | null;
  waived_at?: string | null;
  waived_by_user_id?: string | null;
};
export type MissingListResponse = {
  items: MissingItemResponse[];
  page: number;
  per_page: number;
  total: number;
};
export type LastRequestOutcomeResponse3 = {
  /** When that attempt was made */
  at?: string | null;
  /** sms | email — the channel this outcome describes. Null when no channel was tried at all, which is what no_eligible_channel means. */
  channel?: string | null;
  /** Why it failed, when it did: invalid_address | unreachable | unsubscribed | no_eligible_channel | failed_other. The causes differ in what staff can do — an address is fixable, an opt-out is not and re-sending it is a compliance problem — so the copy is per cause rather than one line for all failures. Only SMS carries a vendor code today, so every email failure reports failed_other; treat that as "we do not know", not as "the address is fine". */
  reason?: string | null;
  /** delivered | failed. Delivered rests on a delivery confirmation from the carrier, not on the message having been accepted for sending. */
  status: string;
};
export type RequirementResponse2 = {
  assigned_at?: string | null;
  /** Product vocabulary: Missing|Received|Waived|Cancelled */
  display_state: string;
  evidence_type?: string | null;
  /** A live update request exists (Send reads Remind) */
  has_active_session?: boolean;
  /** The definition's kind (payment_method | ...) */
  kind?: string | null;
  /** The definition's org-facing label */
  label?: string | null;
  /** Channel of that attempt (sms | email) */
  last_request_channel?: string | null;
  /** What became of the last request. Null when no request was ever made, and while one is still in flight — delivery is claimed only once the carrier says so. A failed outcome is what distinguishes a requirement nobody has chased from one that was chased and never arrived. */
  last_request_outcome?: LastRequestOutcomeResponse3 | null;
  /** When the latest accepted request attempt was sent */
  last_requested_at?: string | null;
  patient_id: string;
  patient_requirement_definition_id: string;
  patient_requirement_id: string;
  pinned_version?: number | null;
  satisfied_at?: string | null;
  /** Storage state: open|satisfied|waived|cancelled */
  state: string;
  waive_reason?: string | null;
  waived_at?: string | null;
  waived_by_user_id?: string | null;
};
export type RequirementListResponse = {
  items: RequirementResponse2[];
  /** Count of rows in the Missing display state (AC-3) */
  missing_count: number;
};
export type LastRequestOutcomeResponse4 = {
  /** When that attempt was made */
  at?: string | null;
  /** sms | email — the channel this outcome describes. Null when no channel was tried at all, which is what no_eligible_channel means. */
  channel?: string | null;
  /** Why it failed, when it did: invalid_address | unreachable | unsubscribed | no_eligible_channel | failed_other. The causes differ in what staff can do — an address is fixable, an opt-out is not and re-sending it is a compliance problem — so the copy is per cause rather than one line for all failures. Only SMS carries a vendor code today, so every email failure reports failed_other; treat that as "we do not know", not as "the address is fine". */
  reason?: string | null;
  /** delivered | failed. Delivered rests on a delivery confirmation from the carrier, not on the message having been accepted for sending. */
  status: string;
};
export type RequirementResponse3 = {
  assigned_at?: string | null;
  /** Product vocabulary: Missing|Received|Waived|Cancelled */
  display_state: string;
  evidence_type?: string | null;
  /** A live update request exists (Send reads Remind) */
  has_active_session?: boolean;
  /** The definition's kind (payment_method | ...) */
  kind?: string | null;
  /** The definition's org-facing label */
  label?: string | null;
  /** Channel of that attempt (sms | email) */
  last_request_channel?: string | null;
  /** What became of the last request. Null when no request was ever made, and while one is still in flight — delivery is claimed only once the carrier says so. A failed outcome is what distinguishes a requirement nobody has chased from one that was chased and never arrived. */
  last_request_outcome?: LastRequestOutcomeResponse4 | null;
  /** When the latest accepted request attempt was sent */
  last_requested_at?: string | null;
  patient_id: string;
  patient_requirement_definition_id: string;
  patient_requirement_id: string;
  pinned_version?: number | null;
  satisfied_at?: string | null;
  /** Storage state: open|satisfied|waived|cancelled */
  state: string;
  waive_reason?: string | null;
  waived_at?: string | null;
  waived_by_user_id?: string | null;
};
export type WaiveRequest = {
  /** Why this is waived (non-blank, capped) */
  reason: string;
};
export type DeliveryAttemptResponse = {
  channel: string;
  last_error?: string | null;
  patient_update_session_id: string;
  scheduled_at?: string | null;
  sequence: number;
  status: string;
};
export type SessionSummary = {
  completed_at?: string | null;
  created_at?: string | null;
  expires_at: string;
  identity_verified_at?: string | null;
  link_opened_at?: string | null;
  patient_id: string;
  patient_update_session_id: string;
  requirement_ids: string[];
  state: string;
};
export type DeliveryTouchpointResponse = {
  channel: string;
  delivered_at?: string | null;
  failed_at?: string | null;
  /** Whether this message went out as a reminder, recorded when it was sent and carrying exactly what its own body said. Null for a message sent before that was recorded, which is the honest answer rather than a guess. */
  is_reminder?: boolean | null;
  /** The session this message belongs to, so a row can be joined to its attempt. Null for a message sent before the send recorded it. */
  patient_update_session_id?: string | null;
  /** The message payload, secure link included */
  payload?: {
    [key: string]: any;
  };
  queued_at?: string | null;
  sent_at?: string | null;
  /** The attempt's position in its session AND CHANNEL ladder. Not a count of messages the patient received: a send that reached nobody spends a sequence too, and each channel counts separately. Use is_reminder for what to call this message. */
  sequence?: number | null;
  status: string;
  touchpoint_id: string;
};
export type DeliveryHistoryResponse = {
  attempts: DeliveryAttemptResponse[];
  /** True → the staff action reads Remind, not Send */
  has_active_session: boolean;
  sessions: SessionSummary[];
  touchpoints: DeliveryTouchpointResponse[];
};
export type SessionSummary2 = {
  completed_at?: string | null;
  created_at?: string | null;
  expires_at: string;
  identity_verified_at?: string | null;
  link_opened_at?: string | null;
  patient_id: string;
  patient_update_session_id: string;
  requirement_ids: string[];
  state: string;
};
export type SendOutcomeResponse = {
  accepted_channels: string[];
  failed_channels: string[];
  /** True when the session had already landed a message, which is what these messages say in their bodies. A live session alone is not enough: a send that reached nobody leaves one behind too. */
  is_reminder: boolean;
  session: SessionSummary2;
};
export type SendRequestBody = {
  /** Override the channels to attempt. Omit to derive them from the patient's communication preferences and contact info, which is the normal path. An empty list is rejected: omit the field to let the server decide. */
  channels?: ("sms" | "email")[] | null;
};
